import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34e63773"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topban" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "zhengque" }, "治疗方案公布")
], -1))
const _hoisted_3 = { class: "ding" }
const _hoisted_4 = { class: "gongbu1" }
const _hoisted_5 = { class: "gongbu2" }
const _hoisted_6 = { class: "gongbu3" }
const _hoisted_7 = { class: "gongbu4" }
const _hoisted_8 = { class: "gongbu6" }
const _hoisted_9 = { class: "bottomBox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_image, {
        width: "2.3733rem",
        height: ".52rem",
        src: require('../assets/newlogo.png')
      }, null, 8, ["src"])
    ]),
    _createVNode(_component_van_popup, {
      show: true,
      style: {"top":"50%"}
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_image, {
              width: "8.4667rem",
              height: ".8533rem",
              src: require('../assets/gongbu1.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_van_image, {
              width: "8.4133rem",
              height: "3.6933rem",
              src: require('../assets/gongbu2.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_van_image, {
              width: "8.4667rem",
              height: ".8533rem",
              src: require('../assets/gongbu3.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_van_image, {
              width: "8.4133rem",
              height: "2.8533rem",
              src: require('../assets/gongbu4.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_image, {
              width: "7.7067rem",
              height: ".88rem",
              src: require('../assets/gongbu6.png')
            }, null, 8, ["src"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_van_image, {
            onClick: $options.biji,
            width: "6.1067rem",
            height: "1.1467rem",
            src: require('../assets/bijibtn.png')
          }, null, 8, ["onClick", "src"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_toNav, { menu: 4 })
  ], 64))
}